import React, { useState, useEffect } from "react";
import "./AssignmentPage.css";
import { Helmet } from "react-helmet-async";

const assignments = [
  {
    title: "Living Palette System",
    url: "https://codepen.io/grauconejo13/pen/pvbqRed",
  },
  {
    title: "The 2026 Fireworks Sequence (Pudgy Edition)",
    url: "https://codepen.io/grauconejo13/pen/ogxRKRE",
  },
  {
    title: "Hygge Haven — A Cozy Winter Shop UI",
    url: "https://codepen.io/grauconejo13/pen/NPNeXwp",
  },
];

function AssignmentPage() {
  // ✅ Handle base URL for both Netlify and your .com domain
  const [baseUrl, setBaseUrl] = useState("");

  useEffect(() => {
    const origin = window.location.origin;
    if (origin.includes("netlify.app")) {
      setBaseUrl("https://vanessainthefifthdimension.netlify.app");
    } else if (origin.includes("vanessainthefifthdimension.com")) {
      setBaseUrl("https://vanessainthefifthdimension.com");
    } else {
      setBaseUrl(origin); // fallback (localhost)
    }
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="assignment-wrapper">
      <Helmet>
        <title>Assignment Showcase | Vanessa Victorino</title>
        <meta
          name="description"
          content="Explore my web development assignments — interactive projects, form validation, JavaScript utilities, and UI design experiments."
        />
        <meta name="author" content="Vanessa Victorino" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Assignment Showcase | Vanessa Victorino"
        />
        <meta
          property="og:description"
          content="Explore creative and technical works by Vanessa Victorino — from early web design to modern JavaScript builds."
        />
        <meta property="og:url" content={`${baseUrl}/assignments`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${baseUrl}/preview-home.jpg`} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Assignment Showcase | Vanessa Victorino"
        />
        <meta
          name="twitter:description"
          content="Assignments and side projects built by Vanessa Victorino."
        />
        <meta name="twitter:image" content={`${baseUrl}/twitter-home.jpg`} />
      </Helmet>

      {/* Fixed header section */}
      <header className="assignment-header">
        <h2>Assignment Showcase</h2>
        <div className="tab-buttons">
          {assignments.map((assignment, index) => (
            <button
              key={index}
              className={`tab-btn ${index === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
              aria-label={`Show ${assignment.title}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </header>

      {/* Scrollable iframe view */}
      <main className="assignment-view">
        <iframe
          key={activeIndex}
          title={assignments[activeIndex].title}
          src={assignments[activeIndex].url}
          className="assignment-frame"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </main>
    </div>
  );
}

export default AssignmentPage;
